import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup'

// Define the sections for the table of contents
const sections = [
  { id: 'section1', title: 'Basic Info' }, // Each section has an ID and a title
  { id: 'section2', title: 'Gallery' },
  { id: 'section3', title: 'Person Updates' },
  { id: 'section4', title: 'PersonTags' },
  { id: 'section5', title: 'Articles' },
  { id: 'section6', title: 'Personal and Background Info' },
  { id: 'section7', title: 'Family & Relationships' },
  { id: 'section8', title: 'Favorites and Preferences' },
  { id: 'section9', title: 'Career' },
  { id: 'section10', title: 'MovieHits' },
  { id: 'section11', title: 'Personal Assets and Social Media' },
  // { id: 'section10', title: 'Public Interaction and Media' }, // Commented out section
  { id: 'section12', title: 'Achievements and Honors' },
  { id: 'section13', title: 'Rumors and Controversies' },
  { id: 'section14', title: 'Business Ventures' },
  { id: 'section15', title: 'Politics' },
  // Add more sections as needed
]

const TableOfContents = ({ activeSection, handleSectionClick }) => (
  <div style={{ position: 'sticky', top: '0' }}>
    <ListGroup>
      {/* Map through sections array to create list items for each section */}
      {sections.map(section => (
        <ListGroup.Item
          key={section.id}
          active={activeSection === section.id}
          onClick={() => handleSectionClick(section.id)} // Handle click event for selecting section
          action // Make the list item clickable
          variant='light' // Light variant for list item
        >
          {section.title}
        </ListGroup.Item>
      ))}
    </ListGroup>
  </div>
)

export default TableOfContents // Export TableOfContents component
